import {Registration} from "../../models/registration";

export default{
    methods: {
        load_on_created() {
            window.edit = this
            return Promise.all([
                this.loadRegistration(),
                this.$store.dispatch("login").then(this.loadDeps)
            ]).then(this.allLoaded)
        },
        loadRegistration() {
            let url = ''
            if (this.$route.meta.template_preview){
                url = `/registrations/new.json?program_id=${"template-" + this.$route.params.id}&template_preview=true&locale=${I18n.locale}`
            } else if(this.$route.meta.new_reg){
                url = `/registrations/new.json?program_id=${this.$route.params.id}&locale=${I18n.locale}`
            } else {
                url = this.scope_path(`/registrations/${this.$route.params.id}/edit.json?locale=${I18n.locale}`)
            }
            return this.axios.get(url).then((resp) => {
                this.state.current_reg = new Registration(resp.data)
                this.state.current_reg.preview = this.preview
                this.reg_loaded = true

                if(this.$route.query.validate_section_limitations && !this.state.current_reg.sections_valid){
                    this.modal.show= true
                }
            })
        },
        async loadDeps(){
            // preload org if provisioned reg
            if (this.state.current_user.current_org_id){
                this.$store.dispatch('loadOrg')
            }
            if(this.state.current_user.id && !this.preview){this.people = await this.$store.dispatch("reg_store/people_family")}
            this.all_loaded = true
        },
        allLoaded(){
            this.state.current_reg.setPerson(this.people, this.state.current_reg.person_id)
            // this.state.current_reg.update_reg_form_blocks(this.state.current_reg.person)
            // this.state.current_reg.fillPersonData(this.people)

            this.state.current_reg.loaded = true
        },
        async reload(){
            // this.people = await this.$store.dispatch("reg_store/people_family", false)
            // this.state.current_reg.setPerson(this.people, this.state.current_reg.person_id)
        },
        scope_path(path){
            if (this.$route.params.organization_id){
                return `/organizations/${this.$route.params.organization_id}${path}`
            }else{
                return path
            }
        }
    }
}
